/** Public gateway for hosted DEV EventQ (matches `proxy.dev.conf.json`). */
export const DEV_GATEWAY_ORIGIN = 'https://public-gw-dev.stealthmonitoring.net';

/** Public gateway for hosted QA/UAT/production EventQ (matches `proxy.uat.conf.json`). */
export const UAT_GATEWAY_ORIGIN = 'https://public-gw-uat.stealthmonitoring.net';

/** @deprecated Use `DEV_GATEWAY_ORIGIN`. Kept for existing interceptor/media specs. */
export const DEV_UAT_GATEWAY_ORIGIN = DEV_GATEWAY_ORIGIN;

export interface HostedGatewayOrigins {
  apiOrigin: string;
  authOrigin: string;
}

/**
 * Gateway for the host the browser is on. Wins over the baked-in env so a DEV
 * bundle served at eventq-uat still uses the UAT gateway.
 */
export function hostedGatewayOriginsForHostname(hostname: string): HostedGatewayOrigins | null {
  const host = hostname.trim().toLowerCase();
  if (!host || host === 'localhost' || host.endsWith('.localhost')) {
    return null;
  }
  if (host.includes('eventq-dev.')) {
    return { apiOrigin: DEV_GATEWAY_ORIGIN, authOrigin: DEV_GATEWAY_ORIGIN };
  }
  if (host.includes('eventq-uat.') || host.includes('eventq-qa.') || host === 'eventq.ecam.com') {
    return { apiOrigin: UAT_GATEWAY_ORIGIN, authOrigin: UAT_GATEWAY_ORIGIN };
  }
  return null;
}

/** App URLs for the host the browser is on (boot log + sibling links). */
export function hostedAppUrlsForHostname(
  hostname: string,
  origin: string,
): { eventqAppBaseUrl: string; resolveAppBaseUrl: string; resolveUrl: string } | null {
  if (!hostedGatewayOriginsForHostname(hostname)) {
    return null;
  }
  const base = origin.replace(/\/$/, '');
  if (!base) {
    return null;
  }
  return {
    eventqAppBaseUrl: base,
    resolveAppBaseUrl: `${base}/resolve`,
    resolveUrl: `${base}/resolve`,
  };
}
